module.exports = {
  "level1": {
    "name": "Echter Name",
    "address": "Aktuelle Anschrift",
    "bank_number": "Bankkontonummer",
    "wc": "OK",
    "name_nodata": "Name darf nicht leer sein",
    "id_card_nodata": "Ausweisnummer darf nicht leer sein",
    "address_nodata": "Anschrift darf nicht leer sein",
    "bank_number_nodata": "Bankkontonummer darf nicht leer sein",
    "input-username": "Bitte Ihren echten Namen eingeben",
    "zjhm": "Ausweisnummer",
    "input-idcard": "Bitte Ausweisnumemr eingeben",
    "input-address": "Bitte Anschrift eingeben",
    "zjlx": "Art des gültigen Ausweises",
    "qxzzjlx": "Bitte Art von Anschrift wählen",
    "sfz": "Personalausweis",
    "hz": "Pass",
    "jsz": "Führerschein",
    "khh": "Bankkonto",
    "qsrkhh": "Bitte geben Sie die Bank ein",
    "yhkh": "Bankkontonummer",
    "qsryhkh": "Bitte Bankkontonummer eingeben",
    "gjlb": "Liste der länder.",
    "qxzgjlb": "Bitte wählen Sie Land / Region"
  },
  "my": {
    "mqrcode": "Mein QR-Code",
    "as": "Einstellungen",
    "pc": "Junior-Zertifizierung",
    "ac": "Senior-Zertifizierung",
    "ms": "Teilen",
    "me": "Meine Erträge",
    "zsr": "Gesamterträge",
    "mp": "Meine Förderungen",
    "yqhy": "Freunde einladen",
    "ar": "Aufzeichnungen",
    "hc": "Hilfezentrum",
    "nodata": "Keine Daten",
    "med": "Verteilungsrechnung",
    "aes": "Kumulativer Ertrag (USDT)",
    "one": "Erste Gen",
    "two": "Zweite Gen",
    "three": "Dritte Gen",
    "four": "Vierte Gen",
    "ones": "Person der ersten Gen",
    "twos": "Person der zweiten Gen",
    "threes": "Person der vierten Gen",
    "fours": "Person der fünften Gen",
    "promotion": "Anzahl der Förderungen",
    "customers": "Meine Erträge",
    "wdzc": "Meine Assets",
    "wdzc1": "Meine Assets",
    "wyfx": "Teilen",
    "wdsy": "Meine Erträge",
    "wdtg": "Meine Förderungen",
    "zhjl": "Aufzeichnungen",
    "zxkf": "Kontaktiere uns",
    "wdxx": "Meine Nachrichten",
    "smrz":"KYC-Authentifizierung",
    "sfyz":"KYC-Authentifizierung"
  },
  "footer": {
    "home": "Startseite",
    "quotation": "Märkte",
    "currency": "Umtauschen",
    "lever": "Verträge",
    "my": "Konto",
    "lc": "Erhaltene USDT-Zinsen "
  },
  "index": {
    "wdzc": "Meine Assets (USDT)",
    "dl": "Einloggen",
    "zxkf": "Kontaktiere uns",
    "increase": "Liste der Gewinne",
    "usercenter": "Persönliches Zentrum",
    "security": "Sicherheitszentrum",
    "address": "Adresse der Abhebung",
    "aboutus": "Über uns",
    "vol": "24-Stunden-Volumen",
    "kjcb": "Währung aufladen",
    "zcbz": "BTC, USDT...",
    "logout":"Ausloggen",
    "language":"Sprache"
  },
  "transaction": {
    "buy": "Kaufen",
    "sell": "Verkaufen",
    "pwd": "Passwort für Transaktionen",
    "inputnum": "Betrag eingeben",
    "limit": "Grenze",
    "avaiable": "Verfügbar",
    "turnover": "Umsatz",
    "handicap": "Hindernis",
    "number": "Betrag",
    "nonumber": "Nicht abgeschlossene Beträge",
    "numbered": "Abgeschlossene Beträge",
    "price": "Preis",
    "marketprice": "Marktpreis",
    "cancel": "Abbrechen",
    "time": "Zeit",
    "nomore": "Nicht mehr",
    "nodata": "Keine Aufzeichnungen",
    "getmore": "Mehr laden",
    "mycommission": "All-Stop-Handel",
    "currentbuy": "Aktuelle Bestellung (Gekauft)",
    "currentsell": "Aktuelle Bestellung (Verkauft)",
    "his": "Historie (Abgeschlossen)",
    "currency": "Währung",
    "option": "Bedienung",
    "wtime": "Zeit der Fertigstellung",
    "wnumber": "Anzahl der Fertigstellungen",
    "wprice": "Preis der Fertigstellung"
  },
  "mk": {
    "high": "Hoch",
    "low": "Niedrig",
    "vol": "24-Stunden-Volumen",
    "newPrice": "Aktuellster Preis",
    "product": "Produkt",
    "name":"Name",
    "rank": "Liste der Gewinne"
  },
  "deals": {
    "issue_time": "Zeit der Ausgabe",
    "issue_number": "Menge der Ausgabe",
    "white_book": "Weißes Papier",
    "weburl": "Offizielle Webseite",
    "video_url": "Video",
    "introduction": "Info",
    "onhand": "1lot =",
    "position": "Position",
    "leverorder": "Hebel-Bestellungen",
    "leverposition": "Hebel-Position",
    "inputprice": "Preis eingeben",
    "inputmul": "Vielfache eingeben",
    "selectmul": "Vielfache wählen",
    "onehand": "1lot =",
    "hand": "Handel-Lots",
    "marketval": "Marktwert",
    "bond": "Bonds",
    "balance": "Saldo",
    "type": "Typ",
    "risk": "Risikorate",
    "total": "Gesamtprofit",
    "onekey": "Ein-Klick-Liquidation",
    "makemore": "(Lang)",
    "makeless": "(Kurz)",
    "current": "Aktuelle Aufträge",
    "all": "Alle",
    "weing": "Auftrag läuft",
    "tding": "Wird gehandelt",
    "ping": "Wird geschlossen",
    "pied": "Abgeschloss",
    "ceiled": "Abgehoben",
    "weprice": "Preis der Kommission",
    "oprice": "Preis der Eröffnung",
    "nowprice": "Aktueller Preis",
    "zyprice": "Take-Profit-Preis",
    "zsprice": "Stop-Loss-Preis",
    "canbond": "Verfügbare Bonds",
    "optime": "Eröffnungszeit",
    "pgtime": "Schließzeit",
    "znum": "Konvertierte Menge",
    "gprice": "Gebühren über Nacht",
    "pcang": "Schließen",
    "revoke": "Abheben",
    "fee": "Gebühren",
    "you": "Optimaler Marktpreis"
  },
  "assets": {
    "copy": "Kopieren",
    "avaiable": "Verfügbar",
    "lock": "Einfrieren",
    "conversion": "Konversion",
    "exact": "Konto der Transaktion",
    "num": "Betrag",
    "time": "Zeit",
    "all": "Alle",
    "canuse": "Verfügbar",
    "cmoney": "Währung aufladen",
    "tmoney": "Währung abheben",
    "caddress": "Adresse der Aufladung",
    "copyaddress": "Adresse kopieren",
    "taddress": "Adresse der Abhebung",
    "taddressm": "Bitte Adresse der Abhebung eingeben",
    "rate": "Gebühren",
    "dnum": "Eingehender Betrag",
    "more": "Mehr laden",
    "nodata": "Keine Aufzeichnungen",
    "yczc": "Assets, die Sie nicht haben, ausblenden",
    "total":"Asset-Konvertierung (USDT)"
  },
  "td": {
    "drecord": "Aufzeichnungen der Bestellungen",
    "orecord": "Aufzeichnungen der abgeschlossenen Bestellungen",
    "filter": "Filtern",
    "dstatus": "Status der Bestellung",
    "nofinish": "Noch nicht abgeschlossen",
    "finished": "Abgeschlossen",
    "ceiled": "Abbgebrochen",
    "reset": "Zurücksetzen",
    "confirm": "OK",
    "time": "Zeit",
    "num": "Betrag",
    "price": "Preis",
    "ptime": "Zeit der Bestellung",
    "receiver": "Zahlungsempfänger",
    "open": "Bankkonto",
    "pwd": "Passwort für Transaktionen",
    "ppwd": "Bitte Passwort zur Transaktion eingeben",
    "sure": "OK",
    "realName": "Echter Name",
    "pnum": "Bitte Betrag eingeben",
    "buyNum": "Gekaufte Menge",
    "currency": "Währung"
  },
  "fat": {
    "ceil": "Abbrechen",
    "num": "Betrag",
    "submit": "Bestellungen",
    "pwd": "Passwort für Transaktionen",
    "ppwd": "Bitte Passwort zur Transaktion eingeben",
    "sure": "Bestätigen",
    "auHigh": "Senior-Zertifizierung"
  },
  "auth": {
    "bh": "Abgelehnt",
    "mycenter": "Persönliches Zentrum",
    "test": "KYC",
    "testing": "Wird geprüft",
    "name": "Name",
    "account": "Konto",
    "id_card_face": "Bitte laden Sie die Vorderseite des Ausweises hoch",
    "id_card_back": "Bitte laden Sie die Rückseite des Ausweises hoch",
    "updata": "Einreichen",
    "updata_again": "Erneut einreichen"
  },
  "code": {
    "notice": "Anküdigungen"
  },
  "safe": {
    "title": "Kontosicherheit",
    "center": "Sicherheitszentrum",
    "yysz": "Sprache",
    "ssms": "Dunkler Modus",
    "gywm": "Über uns",
    "lgpwd": "Login-Passwort",
    "resetpwd": "Passwort ändern",
    "paccount": "Bitte Telefonnummer und Mailbox eingeben",
    "reset": "Ändern",
    "ceil": "Abbrechen",
    "pcode": "Verifizierungs-Schlüssel",
    "sure": "Bestätigen",
    "newPwd": "Passwort zurückstellen",
    "ppwd": "Passwort eingeben",
    "reppwd": "Passwort erneut eingeben",
    "repwd": "Passwort zurückstellen",
    "zpwd": "Passwort für Transaktionen"
  },
  "met": {
    "open": "Name des Bankkontos",
    "bank": "Bankkonto",
    "realname": "Echter Name",
    "save": "Speichern",
    "popen": "Bitte Name des Bankkontos eingeben",
    "pbank": "Bitte Kontonummer eingeben",
    "pname": "Bitte Ihren echten Namen eingeben"
  },
  "ads": {
    "tas": "Adresse der Abhebung",
    "address": "Adresse",
    "noads": "Sie haben noch keine Adresse",
    "adds": "Adresse",
    "remark": "Bemerkung",
    "cel": "Löschen"
  },
  "jc": {
    "ppwd": "Passwort eingeben"
  },
  "lg": {
    "welcome": "Willkommen! Bitte loggen Sie sich ein.",
    "lgtel": "Über Mobiltelefon einloggen",
    "lgeml": "Über E-Mail einloggen",
    "paccount": "Telefonnummer oder E-Mail",
    "ppwd": "Passwort eingeben",
    "ppwd2": "Bitte Passwort bestätigen",
    "pcode": "Verifizierungs-Schlüssel",
    "qsryqm": "Verifizierungs-Schlüssel",
    "noaccount": "Haben Sie noch kein Konto?",
    "register": "Registrieren",
    "phregister": "Über Mobiltelefon registrieren",
    "emregister": "Über E-Mail registrieren",
    "pphone": "Handynummer",
    "ceil": "Abbrechen",
    "send": "CAPTCHA erhalten",
    "sure": "OK",
    "email": "E-Mail-Addresse",
    "emtest": "Verfizierung über E-Mail",
    "pemcode": "Verifizierungs-Schlüssel",
    "ppcode": "Bitte Verifikationscode eingeben",
    "ftpwd": "Passwort vergessen?",
    "ptext": "Bitte Telefonnummer und Mailbox eingeben",
    "yzm": "Verfikationscode",
    "mm": "Passwort",
    "qrmm": "Bitte Passwort bestätigen",
    "language":"Sprache",
    "qregister":"Registrieren",
    "lgs":"Einloggen",
    "ftpwds":"Passwort vergessen",
    "kjzc": "Kontaktieren Sie uns, um bei der Registrierung zu helfen",
    "kjzc1": "Kann Captcha nicht empfangen?",
    "kjzc2": "Schnelle Anmeldung",
    "wyzx": "ich weiß schon",
    "qtxyxzh": "Wichtig: Bitte geben Sie eine gültige E-Mail-Adresse oder Handynummer ein, mit der Sie Ihr Passwort abrufen können",
    "next":"Nächster Schritt"
  },
  "gjrz": {
    "title": "Senior-Zertifizierung",
    "t1": "1. Es werden Bilder unterstützt, die kleiner als 8 MB sind und im JPG-, JPEG- oder PNG-Format vorliegen.",
    "t2": "2. Die Fotos des Dokumente zum Ausweis müssen lesbar sein und dürfen nicht verändert oder gesperrt werden. Das persönliche Foto  und die Dokumentennummer und der Name des Dokumenteninhabers müssen deutlich sichtbar sein.",
    "t3": "3. Die Fotos müssen ohne Kopfbedeckung aufgenommen werden und sollten keine Schminke enthalten. Die Gesichtszüge auf dem Foto sollten klar und deutlich erkennbar sein und die Arme sollten vollständig sichtbar sein.",
    "t4": "OK",
    "bh": "Abgelehnt",
    "shz": "Wird geprüft",
    "shtg": "Genehmigt",
    "sczjz": "Fotos des Ausweises hochladen",
    "sczjzmz": "Vorderseite des Ausweises hochladen",
    "sczjbmz": "Rückseite des Ausweises hochladen",
    "scgrqmz": "Dokumente zum Ausweis und persönliche Unterschrift hochladen"
  },
  "chongzhi": {
    "title": "Währung aufladen",
    "cbjl": "Aufzeichung der Aufladungen",
    "t1": "Betrag",
    "t2": "Bitte Betrag eingeben",
    "t3": "beschreiben(Optional)",
    "t4": "Bitte Beschreibung eingeben",
    "t5": "Abbildung des Gutscheins",
    "t6": "OK",
    "t7": "Name der Kette",
    "t8": "QR-Code",
    "t9": "QR-Code speichern",
    "t10": "Adresse der Aufladung",
    "t11": "Kopieren",
    "zy": "Wichtig",
    "tips1": "Bitte laden Sie keine Assets in dieser Währung an die oben genannte Adresse auf, da die Assets sonst nicht abgerufen werden können",
    "tips2": "1. Wallet/Plattform-Kompatibilität: Das heißt, das Netzwerk wird unterstützt; wenn die Zielplattform Ihr Auszahlungsnetzwerk nicht unterstützt, können die Vermögenswerte nicht abgerufen werden.",
    "tips3": "2. Ihr Aufladenetzwerk und die Zielplattform sind identisch: Wenn Sie als Zieladresse das Ethereum-Netzwerk wählen, die Aufladung jedoch die TRC20-Smart-Chain wählt, können Sie Ihre digitalen Assets möglicherweise nicht abrufen.",
    "tips4": "3. Vergewissern Sie sich vor dem Aufladen, dass Ihre Adresse und Ihr Betrag korrekt sind.",
    "tips5": " Zur Erinnerung: Aufgrund der Anonymität und Privatsphäre des Blocknetzwerks verlieren Sie bei der Eingabe falscher Informationen die entsprechenden Vermögenswerte. Bitte überprüfen Sie Ihre Aufladeadresse und Menge sorgfältig"
  },
  "tibi": {
    "title": "Abheben",
    "tbjl": "Aufzeichnung der Abhebungen",
    "t1": "Adresse der Abhebung",
    "t2": "Bitte Adresse der Abhebung eingeben",
    "t3": "Zu abhebender betrag",
    "qsrtbsl": "Bitte geben Sie die Menge der abzuhebende Währung ein",
    "t4": "Minimum",
    "t5": "Passwort für Transaktionen",
    "t6": "Bitte Passwort zur Transaktion eingeben",
    "t7": "Gebühr",
    "t8": "Eingehender Betrag",
    "t9": "OK",
    "sc": "Löschen",
    "bj": "Bearbeiten",
    "bq": "Tag (Memo)",
    "qsrbq": "Bitte das Tag eingeben",
    "yhktx": "Über Bankkarte abheben",
    "yhmc": "Bankname",
    "qsryhmc": "Bitte Bankname eingeben",
    "yhzh": "Bankkonto",
    "qsryhzh": "Bitte Bankkontonummer eingeben",
    "gjhkdm": "SWIFT-Code",
    "qsrgjhkdm": "Bitte SWIFT-Code eingeben",
    "yhdz": "Adresse der Bank",
    "qsryhdz": "Bitte Adresse der Bank eingeben",
    "skrxm": "Name des Zahlungsempfängers",
    "qsrskrxm": "Bitte Name des Zahlungsempfängers eingeben",
    "skrdh": "Telefon des Zahlungsempfängers",
    "qsrskrdh": "Bitte Telefon des Zahlungsempfängers eingeben",
    "skrdz": "Adresse des Zahlungsempfängers",
    "qsrskrdz": "Bitte Adresse des Zahlungsempfängers eingeben"
  },
  "huazhuan": {
    "t4": "Bitte Betrag eingeben",
    "ky": "Verfügbar",
    "t10": "OK"
  },
  "banner": {
    "title": "Details"
  },
  "download": {
    "t1": "Transaktionen, überall",
    "xz": "Download"
  },
  "xgdlmm": {
    "title": "Login-Passwort ändern",
    "zh": "Konto",
    "yzm": "Verfikationscode",
    "yzmts": "Verifizierungs-Schlüssel",
    "hqyzm": "CAPTCHA erhalten",
    "mm": "Passwort",
    "qrmm": "Bitte Passwort bestätigen",
    "qr": "Bestätigen",
    "zhts":"Handy oder E-Mail",
    "mmts":"Passwort darf aus 6-12 Buchstaben oder Nummern bestehen. "
  },
  "sztkmm": {
    "title": "Passwort zum Abheben einstellen",
    "dlmm": "Login-Passwort",
    "dlmmts": "Bitte geben Sie Ihr Login-Passwort ein",
    "xmm": "Neues Passwort",
    "mmts": "Passwortlänge 6 Ziffern",
    "qrmm": "Bitte Passwort bestätigen",
    "qr": "Bestätigen",
    "qd": "OK",
    "sztkts": "Hinweis: Bitte gehen Sie zum Sicherheitszentrum, um das Transaktionspasswort einzugeben."
  },
  "rule": {
    "title": "Regeln des Events",
    "title2": "Regeln",
    "title3": "Event"
  },
  "news": {
    "title": "Meine Nachrichten",
    "ckxq": "Details anzeigen",
    "gg": "Anküdigungen"
  },
  "search": {
    "qx": "Abbrechen"
  },
  "wdtg": {
    "wdyqlj": "Mein Einladungs-Link",
    "wdyqm": "Mein Einladungs-Code",
    "schbyq": "Postereinladung generieren",
    "ljtgsy": "Einträge Insgesamt",
    "tkrs": "Anzahl der Einladungen",
    "ljyj": "Kumulative Kommission",
    "yjmx": "Details zur Kommission",
    "ljyjjl": "Kumulative Belohnungen zur Kommission (USDT)",
    "ljsy": "Einträge Insgesamt",
    "ljyqjl": "Kumulative Belohnungen zur Einladung (USDT)",
    "fxd": "Teilen mit",
    "bctp": "Abbildungen speichern",
    "qx": "Abbrechen",
    "t3": "Indentifizieren Sie die Abbildung oder sannen Sie sie"
  },
  "bzhl": {
    "title": "Halterabatte",
    "gz": "Regeln",
    "tgdd": "Hinterlegungs-Bestellung",
    "zztgdzj": "Hinterlegte Fonds",
    "yjjrsy": "Erträge heute",
    "ljsy": "Einträge Insgesamt",
    "tgzdd": "Hinterlegte Bestellungen",
    "cljxcp": "Strategische Produkte",
    "dbxe": "Single-Limit",
    "rsyl": "Tägliche Gewinnrate",
    "zq": "Zyklus",
    "qmr": "Jetzt kaufen",
    "bbzhzc": "Konto-Assets",
    "dd": "Bestellungen",
    "buy": "Kaufen",
    "jxcp": "Empfohlene Produkte",
    "ckdd": "Bestellung anzeigen",
    "gd": "Mehr",
    "xzbzts": "Einfach und sicher. Dividenden können in mehreren Währungen ausgewählt werden",
    "qtbz": "Andere Münzen"
  },
  "bzhlgm": {
    "qtzq": "USDT 7-Tage-Zyklus",
    "rsyl": "Ertrag(%)",
    "lczq": "Finanzzyklus",
    "dbxe": "Single-Limit",
    "pxsj": "Auszahlungszeitpunkt der Dividente",
    "mr": "Täglich",
    "dqfh": "Rückerstattung wenn die Frist erreicht wird",
    "tgzj": "Kapital der Hinterlegung",
    "tqsh": "Frühe Rücknahmen",
    "yjsy": "Erwartetes Einkommen (USDT)",
    "kyzc": "Verügbare Assets (USDT)",
    "cpjs": "Über unsere Produkte",
    "tgje": "Betrag der Hinterlegung",
    "qsrtgje": "Bitte geben Sie den Betrag der Hinterlegung ein",
    "qb": "Alle",
    "rm": "Jetzt kaufen",
    "cpzq": "Produkt-Zyklus",
    "gz": "Regeln und Zinsen verstehen"
  },
  "bzhlwdtg": {
    "title": "Status der Bestellung",
    "tgz": "Wird hinterlegt",
    "ywc": "Abgeschlossen",
    "ysh": "Zurückgenommen",
    "tgje": "Betrag der Hinterlegung/Zeit der Hinterlegung",
    "rsyl": "Tägliche Gewinnrate",
    "yhl": "Profitiert",
    "xdsj": "Zeit der Bestellung",
    "sh": "Zurücknehmen",
    "ddxq": "Details der Bestellung",
    "ddh": "Bestellungsnummer"
  },
  "bzjj": {
    "t1": "Jeden Tag gewinnen",
    "cpld": "Produkt-Highlights",
    "scsq": "Jederzeit anzahlen & abheben",
    "pxzq": "Zyklus der Dividende",
    "mtxf": "Täglich verteilt",
    "hqlx": "Aktuelle Zinsen",
    "zj": "100% Förderung",
    "aqbz": "Sicherheit",
    "jjrsy": "Einnahmen an Feirtagen",
    "sybjd": "Kontinuierlicher Profit",
    "bjd": "Ununterbrochen",
    "cgcrh": "Nach erfolgreicher Anzahlung",
    "dtqx": "Zinsenwert an diesem Tag",
    "jglz": "Zum Beispiel",
    "syjs": "Kalkulierung der Erträge",
    "cont2": "Min.: 10000U x 0.3%=30U",
    "cont3": "Max.: 10000U x 0.5%=50U",
    "gywyj": "Über Schadensersatz",
    "wycy": "Ich möchte teilnehmen"
  },
  "zyzs": {
    "title": "Profit nehmen & Verlust stoppen",
    "zy": "Profit nehmen",
    "zs": "Profit nehmen",
    "qsrzyjg": "Bitte geben Sie einen Profitpreis ein",
    "qsrzsjg": "Bitte geben Sie einen Verlustpreis ein",
    "scjg": "Marktpreis",
    "wxts": "Hinweis:",
    "qr": "Bestätigen"
  },
  "bbjy": {
    "mr": "Kaufen",
    "mc": "Verkaufen",
    "mai": "Kaufen",
    "sell": "Verkaufen",
    "xj": "Grenze",
    "sj": "Markt",
    "pk": "Hindernis",
    "jg": "Preis",
    "sl": "Betrag",
    "mrl": "Volumen der Käufe",
    "ss": "Betrag",
    "mcl": "Verkaufsvolumen",
    "ky": "Verfügbar",
    "km": "Verfügbar",
    "ksell": "Vermarktbar",
    "jye": "Umsatz",
    "dqwt": "Aktuelle Aufträge",
    "lswt": "Kommission-Historie",
    "jj": "Info",
    "wtzl": "Gesamt",
    "wtjg": "Preis der Kommission",
    "ycjl": "Volumen der abgeschlossenen Hanelsverfahren",
    "cjjj": "Durchschnitticher Transaktionspreis",
    "cd": "Abheben",
    "xd": "Bestellungen",
    "ywc": "Abgeschlossen",
    "ycd": "Abgehoben",
    "wqcj": "Transaktion abgeschlossen",
    "zx": "Optional",
    "scjg": "Marktpreis",
    "fhsj": "Zeit der Ausgabe",
    "fhsl": "Menge der Ausgabe",
    "bps": "Weißes Papier",
    "gw": "Offizielle Webseite",
    "qx": "Abbrechen"
  },
  "hyjy": {
    "mai": "Kaufen",
    "sell": "Verkaufen",
    "kc": "Positionen öffnen",
    "pc": "Schließen",
    "cc": "Positionen",
    "kp": "Schließen",
    "kpc": "Kurz schließen",
    "kcc": "Positionen",
    "kkd": "Lang schließen",
    "kpd": "Langes Schließen",
    "kkk": "Kurz Öffnen",
    "xj": "Grenze",
    "sj": "Marktpreis",
    "xjwt": "Limit von Kommissionen",
    "sjwt": "Marktpreis",
    "pk": "Hindernis",
    "jg": "Preis",
    "sl": "Betrag",
    "gg": "Hebelwirkung",
    "tzgg": "Hebelwirkung anpassen",
    "ggbs": "Hebelwirkung",
    "mrl": "Volumen der Käufe",
    "ky": "Verfügbar",
    "jye": "Umsatz",
    "dqwt": "Aktuelle Aufträge",
    "lswt": "Kommission-Historie",
    "ptwt": "Normale Kommission",
    "dqwtmr": "Aktuelle Bestellung (Gekauft)",
    "dqwtmc": "Aktuelle Bestellung (Verkauft)",
    "hywt": "Vertrag für Kommission ",
    "jj": "Info",
    "wtzl": "Gesamt",
    "wtjg": "Preis der Kommission",
    "ycjl": "Volumen der abgeschlossenen Hanelsverfahren",
    "cjjj": "Durchschnitticher Transaktionspreis",
    "cd": "Abheben",
    "xd": "Bestellungen",
    "wqcj": "Transaktion abgeschlossen",
    "ywc": "Abgeschlossen",
    "ycd": "Abgehoben",
    "zx": "Optional",
    "scjg": "Marktpreis",
    "fhsj": "Zeit der Ausgabe",
    "fhsl": "Menge der Ausgabe",
    "bps": "Weißes Papier",
    "gw": "Offizielle Webseite",
    "mrzd": "Lang kaufen",
    "mrpk": "Kurz kaufen",
    "mczk": "Kurz verkaufen",
    "mcpd": "Lang verkaufen",
    "mrkdkz": "Offen kaufen (optimistisch)",
    "mrpkkz": "Geschlossen kaufen (optimistisch)",
    "mckkkd": "Offen verkaufen (pessimistisch)",
    "mcpdkd": "Geschlossen verkaufen (pessimistisch)",
    "yxhy": "Unbefristeter Vertrag",
    "dc": "Lange Positionen",
    "syl": "Gewinnrate",
    "bzjl": "Rate der Marge",
    "tzbzj": "Marge anpassen",
    "zyzs": "Profit nehmen & Verlust stoppen",
    "zhang": "Betrag",
    "qblx": "Alle Arten",
    "qb": "Alle",
    "ccjg": "Preis der Position",
    "ccsl": "Quantität der Position",
    "yk": "Profit und Verlust",
    "ccsj": "Zeit der Position",
    "zy": "Profit nehmen",
    "zs": "Profit nehmen",
    "zje": "Gesamtbetrag",
    "kcs": "Quantität der offenenen Positionen",
    "kcjg": "Preis der offenenen Position",
    "ss": "Lot",
    "hand": "1 Lot =",
    "qx": "Abbrechen",
    "qr": "Bestätigen",
    "qbcd":"Alle Bestellungen stornieren"
  },
  "kxt": {
    "gao":"H",
    "di":"L",
    "wtgd": "Ausstehende Bestellung",
    "cj": "Deal",
    "jj": "Info",
    "sj": "Zeit",
    "fx": "Richtung",
    "jg": "Preis",
    "sl": "Betrag",
    "mr": "Kaufen",
    "mc": "Verkaufen",
    "mp": "Angebot",
    "sp": "Verkaufen",
    "slb": "Betrag",
    "fhsj": "Zeit der Ausgabe",
    "fhsl": "Menge der Ausgabe",
    "bps": "Weißes Papier",
    "gw": "Offizielle Webseite",
    "fz":"min",
    "xs":"hour",
    "tian":"day",
    "zhou":"week",
    "yue":"month",
    "gd":"More",
    "ft": "Beiliegendes Bild",
    "zt": "Hauptbild",
    "sdt": "Tiefe",
    "zx": "Optional",
    "djck": "Klicke zum Zeigen"
  },
  "zhjl": {
    "cbtb": "Einbezahlen & Abheben",
    "jymx": "Detail zur Transaktion",
    "tgyj": "Förderungs-Kommission",
    "wwc": "Noch nicht abgeschlossen",
    "ywc": "Abgeschlossen"
  },
  "zwsj": {
    "title": "Keine Daten"
  },
  "bzxz": {
    "title": "Währung wählen"
  },
  "jghy": {
    "jghy": "Eintauschen",
    "yxhy": "Ewig",
    "mz": "Bullisch",
    "md": "Bearisch",
    "gmj": "Kaufpreis",
    "jsj": "Abrechnungspreis",
    "xj": "Aktueller Preis",
    "fx": "Richtung",
    "sl": "Betrag",
    "jgsj": "Liefezeit",
    "gb": "Schließen",
    "jxxd": "Weitere Bestellungen machen",
    "cclb": "Bestellungsliste",
    "zc": "Aktuell",
    "lscc": "Historie",
    "qblx": "Alle Arten",
    "yk": "Profit und Verlust",
    "ddqr": "Bestätigung der Bestellung",
    "dqsj": "Verfallsdatum",
    "jssj": "Lieferzeit",
    "sy": "Profit",
    "tzje": "Preis des Investment",
    "zdje": "Niedrigster Preis höher als 0",
    "kyye": "Balance: ",
    "kyye2": "Balance",
    "sxf": "Gebühr: ",
    "sxfl": "Gebühr",
    "jypz": "Name",
    "jyfx": "Richtung",
    "qrxd": "Bestätigen",
    "dqye": "Aktuelles Saldo"
  },
  "kjmb": {
    "title": "Kryptowährung",
    "gm": "USDT kaufen",
    "wxts": "Hinweis:",
    "copy": "Kopieren",
    "ljmb": "Kryptowährung kaufen",
    "qx": "Abbrechen",
    "gmsl": "Gekaufte Menge",
    "cssl": "Verkaufte Menge",
    "qsrgmsl": "Bitte geben Sie die gekaufte Menge ein",
    "qsrcssl": "Bitte geben Sie die verkaufte Menge ein",
    "jg": "Preis",
    "fzcg": "Erfolgreich kopieren"
  },
  "tips": {
    "jymm": "Passwort für Transaktionen",
    "szjymm": "Passwort zum Abheben einstellen",
    "qsrjymm": "Bitte Passwort zur Transaktion eingeben",
    "jymmts": "Bitte gehen Sie zum Sicherheitszentrum, um das Transaktions-Passwort einzustellen"
  },
  "xyf":{
    "title": "Kreditwürdigkeit",
    "pgsj": "Auswertungszeit"
  },
  "dzrz":{
    "title": "Adressauthentifizierung",
    "sdddz":"Adresse der Stromrechnung",
    "tpsc": "Rechnungsbild hochladen",
    "ts": "Erinnerung: Sie müssen die Adressdaten eingeben und die Stromrechnung oder die Breitbandadressrechnung einreichen",
    "tips":"Sie müssen die Adressdaten eingeben und die Stromrechnung oder die Breitbandadressrechnung einreichen",
    "qsczdtp":"Rechnungsbild hochladen"
  },
  "newReg":{
    "sjh": "Handy, Mobiltelefon",
    "yx": "Email",
    "yqm": "Einladungscode",
    "yqm2": "Einladungscode (optional)",
    "cjzh": "Benutzerkonto erstellen",
    "sysjhzyx": "Mit Handynummer/E-Mail registrieren",
    "sj": "Mobiltelefon",
    "yhxy": "&lt;Benutzervereinbarung&gt;",
    "yhxy2": "Ich habe die &lt;Benutzervereinbarung&gt; gelesen und stimme ihnen zu"
  },
  "mbwt":{
    "title": "Einstellungen für Sicherheitsprobleme",
    "mbwt": "Sicherheitsprobleme",
    "qtxda": "Bitte fülle die Antwort aus",
    "qsrxmm": "Bitte geben Sie ein neues Passwort ein",
    "sydqmmcz": "Aktuelles Passwort zurücksetzen verwenden",
    "zhmm": "Sicherheitsprobleme Passwort abrufen",
    "ysz": "Wurde festgelegt",
    "tg": "über etwas springen",
    "tj": "einreichen",
    "zyts": "Wichtig:",
    "zytsCont": "Geben Sie die geheime Antwort und den Verifizierungscode nicht weiter und denken Sie an das Sicherheitsproblem, das Ihnen beim Abrufen Ihres Passworts hilft"
  },
  "xbsg":{
    "title": "Neue Münze",
    "wdsg": "Einzelheiten",
    "scts": "Sperrtage: ",
    "sy": "verbleibend",
    "ljsg": "Abonniere jetzt",
    "ysk": "Ausverkauft",
    "xzjdy": "Abonniere jetzt",
    "dy": "Abonnieren",
    "fxjg": "Ausgabepreis",
    "fxl": "Verkehr",
    "ssrq": "Angebotsdatum",
    "yxqx": "Gültigkeitszeitraum",
    "qsrsl": "Bitte Betrag eingeben",
    "syl": "verbleibend",
    "sgrq": "Abonnieren",
    "sgsl": "Höhe",
    "bz": "Münze",
    "yebz": "Unzureichendes USDT-Guthaben",
    "tgsl": "Passmenge",
    "shz": "unter Überprüfung",
    "wtg": "Nicht bestanden",
    "ytg": "bestanden"
  },
  "wydb":{
    "title": "Ausleihen",
    "db": "Ausleihen",
    "dbz": "Ausleihen",
    "jl": "aufzeichnen",
    "jdzq": "Zeitraum (Tage)",
    "qhk": "Zurückzahlen",
    "ljdb": "Kumulativ (usdt)",
    "dhkbs" :"Ausstehende Zahlung",
    "jkje": "Kreditbetrag (usdt)",
    "qsrje": "Bitte Betrag eingeben",
    "rll": "Tageszinssatz",
    "hkfs": "Rückzahlung",
    "dqych": "Abgelaufen",
    "lx": "Interesse",
    "fkjg": "Darlehensgeber",
    "tpsc": "Kreditdarlehen (Bild-Upload)",
    "fwxx": "Wohninformationen",
    "srzm": "Einkommensnachweis (Arbeitsverhältnis)",
    "yhmx": "Kontoauszug",
    "zjz": "Ausweisfoto",
    "yd": "Ich habe gelesen und zugestimmt",
    "xy": "Beantragen Sie einen Kreditvertrag",
    "sqdb": "Kreditketten beantragen",
    "gb": "Schließung",
    "qd": "OK",
    "ts": "Bitte überprüfen Sie Kreditvertrag beantragen",
    "dbjl": "aufzeichnen",
    "hkhth": "Bestellcode",
    "wsh": "Ungeprüft",
    "yfk": "Darlehen",
    "sqrq": "Bewerbungszeit",
    "zq": "Kreislauf",
    "dbsl": "Anzahl Rippen",
    "zhke": "Gesamtzahlung",
    "yhkxq": "Rückzahlungsdetails",
    "bqyhk": "Rückzahlbar in der aktuellen Periode(USDT)",
    "hktips": "Bitte stellen Sie sicher, dass das Guthaben ausreicht, wenn das Guthaben nicht ausreicht, laden Sie bitte zuerst auf und zahlen Sie dann zurück",
    "bj": "Rektor",
    "jie": "Ausleihen",
    "ljhk": "Sofort zurückzahlen",
    "qcz": "Deponieren",
    "yebzqxcz": "Unzureichendes Guthaben, bitte zuerst aufladen und dann zurückzahlen",
    "znj": "Gebühr für zu spätes Zahlen",
    "yqts": "Tage überfällig"
  },
  "hkxq":{
    "dd":"Befehl",
    "fzhkdz":"Kopieren Sie die Rückzahlungsadresse",
    "hkxq": "Rückzahlungsdetails",
    "zlx": "Gesamtinteresse",
    "zhk": "Gesamtrückzahlungen",
    "hkjg": "Rückzahlungsstelle",
    "qschkpz": "Bitte laden Sie die Rückzahlungsbescheinigung hoch",
    "hkpz": "Rückzahlungsbescheinigung"
  },
  "bbjyNew":{
    "jylx": "Arten von",
    "jyze": "Menge"
  },
  "indexNew":{
    "title": "Fügen Sie TokenSwap zur Hauptschnittstelle hinzu",
    "t1": " Schneller Zugriff auf das Vollbilderlebnis",
    "t2": " Klicken Sie auf die Symbolleiste unten",
    "t3": "und auswählen",
    "t4": "Zum Startbildschirm hinzufügen",
    "t5": "Vollversion von TokenSwap zur Desktop-Erfahrung hinzufügen",
    "t6": "Zu Favoriten hinzufügen",
    "t7": "Finde auf Seite"
  },
  "bind":{
    "title": "Email",
    "ybd": "Gebunden",
    "wbd": "Ungebunden",
    "yrz": "Verifiziert",
    "wrz": "Unbestätigt",
    "ts": "Um Ihr Konto zu schützen, wird empfohlen, eine E-Mail-Adresse zu binden",
    "qsryxdz": "E-Mail-Addresse"
  },
  "status":{
    "statusText": ['Fehler','Warten auf Bearbeitung','Erfolg'],
 },
 "tipsNew":{
   "wjmmts": "Passwort per Bestätigungscode wiederherstellen",
   "qscpztp": "Gutscheinbild hochladen",
   "emailgsts": "Bitte geben Sie eine gültige Email-Adresse ein",
   "telgsts": "Die Handynummer ist falsch",
   "lcmmbyz": "Bitte bestätigen Sie Ihr Passwort",
   "zdsl": "Minimum ",
   "sldydy": "Menge größer oder gleich",
   "zxtzsl": "Minimum ",
   "ddz": "Warten",
   "xs": "Stunde",
   "min": "Mindestbetrag ",
   "max": "Höchstbetrag ",
   "yebz": "Mangelhaftes Gleichgewicht",
   "qsrss": "Bitte geben Sie das Los ein",
   "zdss": "Mindestlose",
   "yjj": "abgelehnt",
   "shz": "Erlösung",
   "zwkfcz": "Diese Währung kann noch nicht aufgeladen werden",
   "jiaoge": "Lieferung",
    "zhang": "erhebe dich",
    "die": "Herbst",
    "cjxnzh": "Virtuelles Konto erstellen",
 },
 "langNew2":{
  "flzq": "Belohnungszentrum",
  "qdjl": "Belohnung anmelden",
  "mrqdjl": "Tägliche Anmeldebelohnung",
  "qd": "anmelden",
  "yqd": "Angemeldet",
  "hdgz": "Veranstaltungsregeln",
  "qdjl2": "Check-in-Aufzeichnung",
  "qdcg": "Melden Sie sich erfolgreich an",
  "yhd": "Erworben",
  "lq": "Empfangen",
  "dyt": "Tag 1",
  "det": "Tag 2",
  "dst": "Tag 3",
  "dsit": "Tag 4",
  "dwt": "Tag 5",
  "dlt": "Tag 6",
  "dqt": "Tag 7",
  "jxz": "in Bearbeitung"
},
"langNew":{
  "kp": "Öffnung",
  "zuoshou": "Gestern erhalten",
  "zg": "Höchste",
  "zd": "am niedrigsten",
  "dqjg": "Derzeitiger Preis",
  "pcjg": "Schlusskurs",
  "gd": "Ausstehende Bestellung",
  "gdj": "Preis der ausstehenden Bestellung",
  "gdjg": "Preis der ausstehenden Bestellung",
  "xfbzj": "Kaution erforderlich: ",
  "ksrfw": "Verfügbarer Eingangsbereich: ",
  "shou": "Viele",
  "fdjyk": "gleitender Nettogewinn und -verlust",
  "pcsl": "Schlussmenge",
  "cx": "widerrufen",
  "qrpc": "Bestätigen Sie, um die Position zu schließen",
  "sx": "Filter",
  "cz": "zurücksetzen",
  "zdl": "wusste",
  "kccg": "Eine Position erfolgreich eröffnet!",
  "xzfx": "Richtung wählen",
  "lx": "Typ",
  "xgcc": "Stellung ändern",
  "szzyzs": "Legen Sie Stop-Profit und Stop-Loss fest",
  "szhb": "Kryptowährung",
  "gjs": "Metall",
  "yy": "Roh",
  "jy": "Handeln",
  "jmhb": "Kryptowährung",
  "gdsj": "Zeit für ausstehende Bestellungen",
  "gdsl": "Ausstehende Bestellmenge",
  "fs": "time"
 }
}



// WEBPACK FOOTER //
// ./src/utils/lang/de.js